import { useEffect } from 'react';

import { useModuleFlags } from '@shared/hooks/use-module-flags';
import { filesMockMode } from '@shared/lib/dev-mocks';
import { setVaultLinksEnabled, type VaultLinks } from '@shared/lib/vault-links';

async function loadVault() {
  const vault = await import('@modules/vault');
  vault.initVault();
  return vault;
}

export function createAppVaultLinks(
  navigateToFile: (fileId: string, conversationId?: string) => void,
): VaultLinks {
  return {
    async availability(fileId) {
      const vault = await loadVault();
      return vault.vaultFileAvailability(fileId);
    },
    async download(fileId) {
      const vault = await loadVault();
      await vault.downloadVaultFile(fileId);
    },
    open(fileId, options) {
      navigateToFile(fileId, options?.conversationId);
    },
  };
}

export function VaultLinksFlagSync(): null {
  const { disabled, fetching } = useModuleFlags();

  useEffect(() => {
    if (fetching) return;
    setVaultLinksEnabled(filesMockMode() !== null || !disabled.has('crm.vault'));
  }, [disabled, fetching]);

  return null;
}
